import React from 'react';
import { FormattedMessage } from 'react-intl';

import { EDefaultWishList, IWishlist } from '../../../domain/wish.interface';

export function WishlistName(props: {wishlist: IWishlist}) {
  const { isDefault, name, id } = props.wishlist;
  if (!!isDefault) {
    const nameToTranslate =
      name === EDefaultWishList.MY_WISHES
        ? 'pages.wishlist_catalogue.default_list_1'
        : 'pages.wishlist_catalogue.default_list_2';
    return (
      <FormattedMessage key={id} id={nameToTranslate}>
        {txt => <option value={id}>{txt}</option>}
      </FormattedMessage>
    );
  } else {
    return (
      <option value={id} key={id}>
        {name}
      </option>
    );
  }
}
